var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-indicator"},[_c('div',{staticClass:"indicator"},[_c('p',[_vm._v(_vm._s(_vm.translate('globals.scroll')))]),_c('img',{attrs:{"src":"assets/images/scroll-icon.png"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444eb39c","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/partials/scroll-indicator.vue
// module id = 387
// module chunks = 0